/* eslint-disable*/
import React, {Component} from "react";
import {Button, Col, Container, Row} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import './ViewLecture.scss';
import * as constants from "../../../const/constants";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as actionCreator from "../../../store/domain/classes/action";
import * as commonFunc from "../../../utils/commonFunc";
import {notifyMessage} from "../../../utils/commonFunc";
import moment from "moment";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as classService from "../../../services/class";
import * as actionModalCreator from "../../../store/domain/modal/action";
import {lang, language} from "../../../const/language";
import swal from "sweetalert";
import {DatePicker} from 'antd';
import 'vimond-replay/index.css';
import toastr from "toastr";
import Share from "../../../assets/img/common/share.png"
import DateIcon from "../../../assets/img/common/date.png"
import ClockIcon from "../../../assets/img/common/clock.png"
import Check from "../../../assets/img/common/checks.png"
import Pencil from "../../../assets/img/common/pencil.png"
import ViberHeader from "../../../components/header-new/ViberHeader";

const {MonthPicker} = DatePicker;
const dateFormat = 'YYYY/MMMM';

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/19/20
 * Time: 1:19 PM
 */

class App extends Component {
    handlePageClick = (value) => {
        this.fetchClassesFromHome(value.selected);
    };
    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };

    checkClass = async () => {
        let state = this.props.location.state;

        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsById(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };


    checkClassByToken = async () => {
        let state = this.props.location.state;

        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsByIdWithToken(state)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success) {
                        this.props.selectClassHandler(response.body);
                    } else {
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    redirectBack = (id) => {
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
            state: `${id}`
        })
    };

    purchaseHandler = (date, classId, classDetails) => {
        this.props.setPaymentModal(true, {classId: classId, classDetails: classDetails})
        // let months = dropdownConst.months;
        // let curMonth = new Date(date).getMonth();
        // let curYear = new Date(date).getFullYear();
        //
        // let obj = { month: months[curMonth].value, year: curYear, classId: classId };
        // commonFunc.studentPurchaseWarning(this.props, obj);
    };
    setModalHandler = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)

    };

    viewClassLessons = () => {
        commonFunc.viewClassResources(this.props, parseInt(this.props.location.state));
    };

    componentWillUnmount() {
        this.props.selectClassHandler(null);
    }

    async componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;

        let pathname = this.props.location.pathname;
        let array = pathname.split('/');
        let hashCode = (array[array.length - 1]);
        let checkType = (array[array.length - 2]);
        this.props.spinnerHandler({isSpin: true, type: 15});
        if (hashCode.length === 6 && checkType === 'pay-class') {
            classService.paymentUrlNavigation(hashCode).then(res => {
                if (res.success) {
                    let isEnrolled = res.body.enrolled;
                    // this.props.spinnerHandler({isSpin: true, type: 10});
                    classService.getClassDetailsById(res.body.classId)
                        .then(response => {
                            this.props.spinnerHandler(false);
                            if (response.success) {
                                this.props.selectClassHandler(response.body);
                                if (!isEnrolled) {
                                    this.props.setPaymentModal(true, {
                                        classId: res.body.classId,
                                        classDetails: response.body
                                    })
                                }
                            } else {
                                commonFunc.notifyMessage(response.message, response.status);
                                this.goHome();
                            }
                        })
                } else {
                    this.goHome();
                }

            })
        } else if (hashCode.length === 6 && checkType === 'join-class') {
            classService.JoinClassNavigation(hashCode).then(
                response => {
                    if (!response.success) {
                        this.props.spinnerHandler(false);
                        classService.getClassDetailsByHashcode(hashCode).then(res => {
                            let classDetails = res.body;
                            this.props.selectClassHandler(classDetails);
                            this.props.location.state = classDetails.id;
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                                state: `${classDetails.id}`
                            })
                        });
                        notifyMessage(response.message, response.status);
                    } else {
                        let obj;
                        let body = response.body;
                        if (body.zoomMeetingJoinType === 'UNAUTHORIZED') {
                            obj = {
                                zoomMeetingId: body.zoomMeetingId,
                                zoomMeetingPassword: body.zoomMeetingPassword,
                                zoomSignatureJwt: body.zoomSignatureJwt,
                                classId: body.classId,
                                zoomMeetingJoinType: body.zoomMeetingJoinType
                            };
                            this.props.spinnerHandler(false);
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                state: obj
                            })
                        } else {
                            classService.joinZoomClassAuthorized(body.classId).then(res => {
                                if (res.success) {
                                    this.props.spinnerHandler(false);
                                    obj = {
                                        link: res.body,
                                        zoomMeetingJoinType: 'AUTHORIZED'
                                    };
                                    // this.props.history.props.spinnerHandler(false);
                                    this.props.history.props.push({
                                        pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                        state: obj
                                    })
                                } else {
                                    //props.spinnerHandler(false);
                                    this.props.spinnerHandler(false);
                                    let msgType = 'warning';
                                    toastr[msgType](res.message);
                                }
                            }).catch(err => {
                                this.props.spinnerHandler(false);
                                console.log(err)
                            });
                        }


                    }
                }
            )
        } else {
            if (this.props.location.search.split('?paynow=')[1] === 'Y') {
                await this.checkClass();
                document.getElementById("pay-btn").click();
            } else {
                await this.checkClassByToken();
            }


        }


    }


    joinClass = (selectClass) => {
        if (this.props.userType === 1) {
            commonFunc.joinClassHandler(this.props, selectClass)
        } else {
            swal({
                title: language[lang].StudentSignInWarning3,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        break;
                    default:
                        break;
                }

            });
        }
    };

    joinFreeClass = async (object, type) => {
        if (object.buttonStatus === constants.BUY_TEXT) {
            if (this.props.userType !== 1) {
                swal({
                    title: type === 'class' ? language[lang].StudentSignInWarning3 : language[lang].StudentSignInWarningForClassLesson,
                    icon: null,
                    closeOnClickOutside: false,
                    buttons: {
                        cancel: language[lang].NotNowText,
                        dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                    },
                }).then((value) => {
                    switch (value) {
                        case "action":
                            window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                            break;
                        default:
                            break;
                    }
                });
            } else {

                this.props.spinnerHandler({isSpin: true, type: 15});

                const data = {
                    classId: object.id,
                    studentId: this.props.userObj.id,
                    year: moment().format('YYYY'),
                    month: moment().format('MMMM').toUpperCase()
                };

                // this.props.spinnerHandler(false);
                await classService.joinFreeClass(data)
                    .then(response => {

                        this.props.spinnerHandler(false);
                        if (response.success) {
                            if (type === 'class') {
                                commonFunc.joinClassHandler(this.props, object)
                            } else {
                                this.viewClassLessons()
                            }
                        } else {
                            commonFunc.notifyMessage(response.message, response.status);
                        }
                    })
            }
        } else {
            if (type === 'class') {
                commonFunc.joinClassHandler(this.props, object)
            } else {
                this.viewClassLessons()
            }
        }
    }

    viewClassPapers = (object) => {
        commonFunc.viewPaperResources(this.props, object.id, true);
    }

    render() {


        let {selectClass, userType} = this.props;

        let firstWeek = new Date().getDate() <= constants.FREE_CLASS_DURATION;
        console.log(selectClass ? selectClass : 'nathoo')

        let activeButtons = (
            <Button
                onClick={() => this.purchaseHandler(new Date(), selectClass.id, selectClass)}
                style={{
                    border: 'none',
                    color: 'white',
                    backgroundColor: 'maroon',
                    borderRadius: 8,
                    width: '100%',
                    padding: 13
                }}>MONTHLY PAYMENT $</Button>
        );

        if (selectClass && selectClass.buttonStatus === constants.PENDING_TEXT) {
            activeButtons = (
                <Button style={{
                    border: 'none',
                    color: 'white',
                    backgroundColor: 'black',
                    borderRadius: 8,
                    width: '100%',
                    padding: 13
                }}>{language[lang].PaymentPendingC}
                </Button>
            );
        }

        if (selectClass && (
            (selectClass.buttonStatus === constants.BOUGHT_TEXT && selectClass.fee === 0) ||
            (selectClass.buttonStatus === constants.BOUGHT_TEXT) ||
            (selectClass.firstWeekFree && firstWeek && selectClass.buttonStatus === constants.BOUGHT_TEXT))) {
            activeButtons = (
                <>
                    {
                        selectClass.teacher.privileges.split(':')[0] === '1' &&
                        <Button
                            onClick={() => commonFunc.joinClassHandler(this.props, selectClass)}
                            style={{
                                border: 'none',
                                color: 'white',
                                backgroundColor: '#00A1FF',
                                borderRadius: 8,
                                width: '100%',
                                padding: 13
                            }}>JOIN ZOOM
                            CLASS</Button>
                    }

                    {
                        selectClass.teacher.privileges.split(':')[1] === '1' &&
                        <Button
                            onClick={() => this.viewClassLessons()}
                            style={{
                                border: 'none',
                                color: 'white',
                                backgroundColor: '#344054',
                                borderRadius: 8,
                                width: '100%',
                                padding: 13
                            }}>WATCH VIDEOS AND PDF</Button>
                    }

                    {
                        selectClass.teacher.privileges.split(':')[3] === '1' &&
                        <Button
                            onClick={() => this.viewClassPapers(selectClass)}
                            style={{
                                border: 'none',
                                color: 'white',
                                backgroundColor: '#344054',
                                borderRadius: 8,
                                width: '100%',
                                padding: 13
                            }}>PAPERS</Button>
                    }
                </>
            );
        }


        return (

            <div>
                <ViberHeader/>
                {/*<Header/>*/}
                <div>
                    <main ref="main">
                        <Container
                            fluid="sm"
                            style={{marginTop: '40px', paddingLeft: '7.5%', paddingRight: '7.5%'}}>
                            <Row>
                                <Col className="" xl={9} sm={12}>
                                    <Row style={{padding: 0}}>
                                        <Col xl={11} md={11} xs={11} sm={11}>
                                            <div style={{
                                                margin: 0,
                                                fontSize: 42,
                                                color: 'black',
                                                fontWeight: 'bold'
                                            }}>{selectClass && selectClass.name}
                                            </div>
                                        </Col>
                                        <Col xl={1} md={1} sm={1} xs={1}
                                             style={{display: 'flex', justifyContent: 'end', alignItems: 'center'}}>
                                            <button>
                                                <span>
                                                    <img src={Share} alt={''}/>
                                                </span>
                                            </button>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            <div style={{
                                                color: 'rgba(75,70,92,0.75)',
                                                fontSize: 19,
                                                paddingBottom: 10
                                            }}>{selectClass && selectClass.teacher.teacherName}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className={"remove-right-border"} style={{borderRight: '1px solid #DBDADE'}}>
                                        <Col style={{paddingTop: 5}}>
                                            <img style={{
                                                width: '100%',
                                                aspectRatio: '3 / 1.6',
                                                // height: '600px',
                                                padding: 0,
                                                borderRadius: '8px'
                                            }}
                                                 src={this.props?.selectClass?.imageUrl} alt={''}/>
                                        </Col>
                                    </Row>

                                    <Row
                                        className={"remove-right-border"}
                                        style={{
                                            paddingTop: '40px',
                                            borderRight: '1px solid #DBDADE',
                                            paddingLeft: 15,
                                            paddingRight: 15
                                        }}>

                                        <Col>

                                            <Row style={{
                                                background: 'linear-gradient(180deg, #bf1919 0%, maroon 100%)',
                                                color: 'white',
                                                padding: '10px',
                                                borderRadius: '8px',
                                            }}>
                                                <Col style={{
                                                    display: 'flex',
                                                    justifyContent: 'start',
                                                    alignItems: 'center'
                                                }}>
                                                    <h5 style={{color: 'white', fontWeight: 'bold'}}>Amount per
                                                        month</h5>
                                                </Col>
                                                <Col style={{
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                    alignItems: 'center'
                                                }}>
                                                    <button style={{
                                                        backgroundColor: 'white',
                                                        fontSize: '20px',
                                                        color: 'maroon',
                                                        padding: '10px',
                                                        borderRadius: '20px',
                                                        fontWeight: 700,
                                                        paddingRight: 25,
                                                        paddingLeft: 25
                                                    }}>
                                                        {selectClass && `${parseFloat(selectClass.fee ? selectClass.fee : 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} LKR`}
                                                    </button>
                                                </Col>
                                            </Row>

                                        </Col>

                                    </Row>

                                    <Row className={"remove-right-border"} style={{
                                        paddingTop: 30,
                                        borderRight: '1px solid #DBDADE',
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>

                                    <Row
                                        className={"remove-right-border"}
                                        style={{paddingTop: 30, borderRight: '1px solid #DBDADE',}}>
                                        <Col style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 8
                                        }}>
                                            <Row style={{paddingBottom: 10}}>
                                                <Col style={{color: 'black'}}>
                                                    About this class
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs={12} sm={12} md={12} xl={12}>
                                                    <span><img
                                                        src={Check}/></span> Grade: {selectClass && selectClass.grade}
                                                </Col>
                                                <Col style={{paddingTop: 10}} xs={12} sm={12} md={12} xl={12}><span><img
                                                    src={Pencil}/></span> Subject: {selectClass && selectClass.subject}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row className={"remove-right-border"} style={{
                                        paddingTop: 30,
                                        borderRight: '1px solid #DBDADE',
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>

                                    <Row className={"remove-right-border"}
                                         style={{paddingTop: 30, borderRight: '1px solid #DBDADE', paddingBottom: 30}}>
                                        <Col>
                                            <div style={{color: 'black', fontWeight: 500}}>Description</div>
                                            <div style={{paddingTop: 10}}>
                                                {selectClass && selectClass.description}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className={"remove-right-border visible-on-small"} style={{
                                        paddingBottom: 30,
                                        borderRight: '1px solid #DBDADE',
                                        paddingLeft: 15,
                                        paddingRight: 15,
                                        visibility: 'hidden'
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>

                                </Col>


                                <Col xl={3} sm={12} xs={12}>
                                    <Row>
                                        <Col style={{display: 'flex', flexDirection: 'column', gap: 15}}>

                                            <div style={{color: 'black', fontSize: 16,}}>Class Schedule</div>


                                            {selectClass && selectClass.dayTimes.map((dateTime, index) => {
                                                return (
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
                                                        <div style={{color: "#5A6080"}}><span>
                                                            <img
                                                                style={{
                                                                    paddingBottom: 2,
                                                                    width: 16,
                                                                    height: 18,
                                                                    marginRight: 10
                                                                }}
                                                                src={DateIcon} alt={''}/></span>
                                                            {`${dateTime.dayName} - ${moment(`2000-01-01 ${dateTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dateTime.endTime}`).format('h:mm a')}`}
                                                        </div>

                                                        <div style={{color: '#5A6080'}}><span>
                                                            <img
                                                                style={{
                                                                    paddingBottom: 2,
                                                                    width: 16,
                                                                    height: 18,
                                                                    marginRight: 10
                                                                }}
                                                                src={ClockIcon} alt={''}/></span>Next Class is on<span
                                                            style={{fontWeight: 'bold'}}>{` ${moment(selectClass.nextDayOfClass.replace("Z", "")).format("YYYY MMM DD ")}`}</span>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        </Col>

                                    </Row>

                                    <Row style={{
                                        paddingTop: 30,
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>

                                    <Row style={{paddingTop: 20}}>
                                        <Col xl={12} style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'start',
                                            paddingTop: '20px',
                                            paddingBottom: '20px',
                                            gap: 12
                                        }}>
                                            {activeButtons}
                                        </Col>
                                    </Row>

                                    <Row style={{
                                        paddingTop: 30,
                                        paddingLeft: 15,
                                        paddingRight: 15
                                    }}>
                                        <Col style={{borderTop: '1px solid #DBDADE',}}></Col>
                                    </Row>

                                    <Row style={{paddingTop: 30}}>
                                        <Col>
                                            <div style={{
                                                color: 'black', fontSize: 16, fontWeight: 400, paddingBottom: 20
                                            }}>About Instructor
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: 'column',
                                                justifyContent: "center",
                                                alignItems: 'center',
                                                textAlign: 'center',
                                                gap: 15
                                            }}>
                                                <img
                                                    width={"250px"}
                                                    height={"250px"}
                                                    alt={""}
                                                    style={{objectFit: 'cover', borderRadius: 8,}}
                                                    src={selectClass && selectClass.teacher.imageUrl}/>
                                                <h2 style={{
                                                    color: 'black',
                                                    fontWeight: 'bold'
                                                }}>{selectClass && selectClass.teacher.teacherName}</h2>
                                                <div>{selectClass && selectClass.teacher.qualification}</div>
                                                <div
                                                    style={{color: 'black'}}>{selectClass && selectClass.teacher.description}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Container>
                    </main>
                    <CardsFooter/>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    selectClass: state.classes.selectClass,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    userObj: state.student.userObj
});


const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
